exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../../../../../postcss-loader/index.js??postcss!../ej.widgets.core.material.min.css"), "");
exports.i(require("-!../../../../../css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../../../../../postcss-loader/index.js??postcss!./ej.theme.min.css"), "");

// module
exports.push([module.id, "\r\n\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/css-loader?{"sourceMap":false,"importLoaders":1}!/home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/postcss-loader?{"ident":"postcss"}!/home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/material/ej.web.all.min.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../syncfusion-javascript/Content/ej/web/material/ej.web.all.min.css
// module chunks = 2